<script>
  export let name;
  export let img;
  export let webp;
  export let party;
  export let backgroundColor;

  $: isThereAHeadshot = (img) => {
    if ((img == 'person_male') | (img == 'person_female')) {
      return false;
    } else {
      return true;
    }
  };

  $: HeadshotExists = isThereAHeadshot(img);
  $: headshotAlt = `Headshot of ${name}`;
  $: noHeadshotAlt = `No photo available for ${name}, generic image`;
</script>

<picture>
  <!-- <source
      type="image/avif"
      srcset={avif}
    /> -->
  <source type="image/webp" srcset={webp} />
  <img
    src={img}
    class={party ? party : ''}
    alt={HeadshotExists ? headshotAlt : noHeadshotAlt}
    width="300"
    height="300"
    style="background-color:{backgroundColor};"
  />
</picture>
